import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-20 min-h-[60vh]">{children}</main>
      <Footer />
    </>
  );
}
